import * as TK from 'components/PDP/Details/components/ProductOptions/components/ViewAvailableProductsAlert/translations/locale.constants';

export const viewAvailableProductsAlertCommonLocale = {
  [TK.INFO]: 'Selected product is not available',
  [TK.BUTTON]: 'View Available Products',
};
